import React, { FC, memo } from 'react'
import { Handle, NodeProps, Position } from 'react-flow-renderer'
import { Person } from './Person'
import { styled } from '@mui/material'

const colors = ['248, 42, 25', '1, 174, 143', '217, 121, 0', '121, 121, 191']
const getRandomnColor = () => colors[Math.floor(Math.random() * colors.length)]

const StyledHandle = styled(Handle)(({ color }) => ({
    width: '12px !important',
    height: '12px !important',
    border: `solid 0.7px ${color} !important`,
    backgroundColor: `${color} !important`,
}))

export const PersonNode: FC<NodeProps> = memo((props) => {
    const colorValue = getRandomnColor()
    const color = `rgb(${colorValue})`

    const {
        data: person,
        isConnectable,
        targetPosition = Position.Top,
        sourcePosition = Position.Bottom,
    } = props

    return (
        <>
            {person.parentId && (
                <Handle
                    type="target"
                    position={targetPosition}
                    isConnectable={isConnectable}
                />
            )}
            <Person person={person} colorValue={colorValue} />
            <StyledHandle
                type="source"
                position={sourcePosition}
                isConnectable={isConnectable}
                color={color}
                //   className={classes.bottomConnector}
            />
        </>
    )
})
